import DEFAULT_SETTINGS from '../../constants/settings'

export * from './helper/PlantHelper'

export function isMobile() {
    const useragent = navigator.userAgent

    if (useragent.match(/Android/i)
        || useragent.match(/webOS/i)
        || useragent.match(/iPhone/i)
        || useragent.match(/iPod/i)
        || useragent.match(/Windows Phone/i)
        || useragent.match(/SymbianOS/i)
        || useragent.match(/RIM/i)
        || useragent.match(/BB/i)
    ) {
        return true
    }

    return false
}

export function settingsFromQuestions(questions) {
    const settings = DEFAULT_SETTINGS

    questions.forEach((question) => {
        if (question.settingsKey && question.answer !== null) {
            const key = question.settingsKey

            if (typeof settings[key] !== 'undefined') {
                settings[key] = question.answer
            } else if (key === 'automatic_mode' && question.answer && !settings.irrigationMode) {
                settings.irrigationMode = 'automatic'
            } else if (key === 'reactive_mode' && question.answer && !settings.irrigationMode) {
                settings.irrigationMode = 'reactive'
            } else if (key === 'alternative_mode' && !settings.irrigationMode) {
                settings.irrigationMode = question.answer
            }
        }
    })

    return DEFAULT_SETTINGS
}

export function isDefaultSensorImage(img) {
    return img === 'https://storage.googleapis.com/staging.flowerai-168618.appspot.com/assets/images/sensor.png'
}

export function isDefaultValveImage(img) {
    return img === 'https://storage.googleapis.com/staging.flowerai-168618.appspot.com/assets/images/valve.png'
}



// WEBPACK FOOTER //
// ./src/components/utilities/helpers.js